/**
 * Calls callback when window.bootstrap is available, using a custom event.
 * Returns a promise that resolves when ready.
 */
function waitForBootstrap(callback) {
    if (window.bootstrap) {
        callback();
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        window.addEventListener("bootstrap-ready", () => {
            callback();
            resolve();
        }, { once: true });
    });
}

function blockModalFocus() {
    window.addEventListener('hide.bs.modal', event => {
        event.target.inert = true;
    });
    window.addEventListener('show.bs.modal', event => {
        event.target.inert = false;
    });
}

export { waitForBootstrap, blockModalFocus };